import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './reglas.css';
import { reglas_item } from '../../json/reglas';

const Reglas = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className='container reglas-container'>
        <div className='row'>
            <div className='col_12'>
                <div className='reglas_title'>
                    <h1>Reglas de operación del programa</h1>
                    <h3>“Fortalecimiento de la Vinculación y Movilidad Laboral, Primero el Pueblo”</h3>
                </div>
            </div>
        </div>
        <div className='row'>
            {
                reglas_item.map((item, index)=>(
                    <div key={ index } className='col-md-6 col-sm-6 col-12 reglas_item'>
                        <Link target='_black' to={ item.reglas_item_url }><b>{ item.reglas_item_titulo }</b> </Link>{ item.convocatorias_item_nombre }
                    </div>
                ))
            }
        </div>
    </div>
  )
}

export default Reglas